import React, { ChangeEvent } from "react";

type PhoneFieldProps = {
  label: string;
  value: string | undefined;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

type PhoneData = {
  homePhone: {
    label: string;
    value?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  },
  mobilePhone: {
    label: string;
    value?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  },
}

type CheckboxData = {
  label: string;
  defaultChecked: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

type PhoneFieldBoxProps = {
  label: string;
  required?: boolean;
  phoneData: PhoneData;
  checkboxData?: CheckboxData;
}

export const PhoneField: React.FC<PhoneFieldProps> = ({ label, value, onChange }) => (
    <li className="list-input__item">
      <span>{label}</span>
      {onChange ? 
        <input type="text" className="input input--pw" placeholder="0311112222" value={value} onChange={onChange} />
      :
        <p className="contact-box__desc">{value}</p>
      }
    </li>
);

export const PhoneFieldBox: React.FC<PhoneFieldBoxProps> = ({ label, required = false, phoneData, checkboxData }) => {

  const showPhoneFields = checkboxData ? !checkboxData.defaultChecked : true;

  return (
    <div className="contact-box__item contact-box__item--start">
      <label className="contact-box__ttl">
        <span>{label}</span>
        { required && <small>必須</small> }
      </label>

      <div className="contact-box__ct">
        {checkboxData && (
          <label className="checkbox-item">
            <input
              type="checkbox"
              defaultChecked={checkboxData.defaultChecked}
              onChange={checkboxData.onChange}
              id="fruitCheckbox"
            />
            <span>{checkboxData.label}</span>
          </label>
        )}
        {showPhoneFields && (
          <>
            <ul className={`list-input ${checkboxData ? "mtpc-10 mtsp-10" : ""}`}>
              <PhoneField label={phoneData.homePhone.label} value={phoneData.homePhone?.value} onChange={phoneData.homePhone?.onChange} />
              <PhoneField label={phoneData.mobilePhone.label} value={phoneData.mobilePhone?.value} onChange={phoneData.mobilePhone?.onChange} />
            </ul>
            {onchange && <p className="contact-box__note">※自宅か携帯いずれか必須</p>}
          </>
        )}
      </div>
    </div>
  )
};
